import { Pipe, PipeTransform } from '@angular/core';
import { Helpers } from '@core/helpers/helpers';
import { environment } from '@env';

@Pipe({
  name: 'file',
})
export class StaticFilePipe implements PipeTransform {


  constructor(
    private helper: Helpers
    ) {
  }

  transform(id: number) {
    return this.getFile(id);
  }

  getFile(id: number) {
    return `${environment.apiUrl}/anexos/${id}/donwload?key=${encodeURIComponent(this.helper.generateApplicationHash())}`;
  }

  /* generateDownloadToken(): string {
    const date = new Date();
    const create = date.setMinutes(date.getMinutes());
    const expire = date.setMinutes(date.getMinutes() + 120);

    var token = {
      data: '',
      createDate: new Date(create),
      expireDate: new Date(expire)
    }
    const password = this.config.hashKey;
    var iv = CryptoJS.enc.Utf8.parse(password);

    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(token)), password,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  } */

}
